<script setup>

import Container from "./kdContainer.vue";

</script>

<template>
  <container>
    <el-form ref="formRef" label-width="128px">
      <el-form-item>
        <el-button type="primary" @click="auditPassBtClick">重新提交</el-button>
        <el-button class="lang-but" type="danger" @click="auditCloseBtClick">取消问题</el-button>
      </el-form-item>
    </el-form>

    <kd-audit-pass-dialog
      :visible.sync="auditPassDialogVisible"
      v-model="form.auditText"
      @confirm="onAuditPassConfirm"
    />
  </container>
</template>

<style scoped lang="scss">

</style>
<script>
import {requestSubmitAudit} from "../../api/feedback";
import {requestSubmitAuditKD} from "@/api/feedbackKD";
import KdAuditPassDialog from "./kdAuditPassDialog.vue";

export default {
  name: "kdManagerSubmit",
  inject: ['getValidateForm'],
  components: { KdAuditPassDialog },
  props: {
    taskId:String,
    questionId:String,
    taskDefKey:String,
    suggestionItems: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      header: {
        satoken: sessionStorage.getItem("token")
      },
      hasFileEchoShow:false,
      imAction: "/manage/staff/upload?fileType=auditResource",
      dialogVisible:false,
      auditPassDialogVisible: false,
      form: {
        auditText: ""
      }
    }
  },
  watch: {
    hasTempSolution: function (val) {
      this.$emit("hasTempSolution", val);
    }
  },
  methods: {
    async auditPassBtClick() {
      if (!await this.getValidateForm()) {
        return
      }
      this.auditPassDialogVisible = true;
    },
    onAuditPassConfirm(auditText) {
      let formData = {
        nowTaskId: this.taskId,
        questionId: this.questionId,
        taskDefKey: this.taskDefKey,
        auditText: auditText,
        variables: {
          approval: true,
        },
      }
      requestSubmitAuditKD(formData).then(res => {
        if (res.status == "0") {
          this.$DonMessage.success('提交成功!');
          this.backRouterPath();
        }else {
          this.$DonMessage.error(res.message);
        }
      })
    },
    auditCloseBtClick() {
      this.$confirm('确认取消质量问题?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let formData = {
          nowTaskId: this.taskId,
          questionId: this.questionId,
          taskDefKey: this.taskDefKey,
          variables: {
            approval: false,
          },
        }
        requestSubmitAuditKD(formData).then(res => {
          if (res.status == "0") {
            this.$DonMessage.success('问题已取消!');
            this.backRouterPath();
          }else {
            this.$DonMessage.error(res.message);
          }
        })
      })
    }
  },
  mounted() {
  }
}
</script>
